module.exports = __webpack_public_path__ + "assets/img/side_right_arrow.6ad71dc5.png";